module.exports = __webpack_public_path__ + "img/stacks.bc769760.png";